import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../utils/httpClient";
const name = "sentToIndividual";
const initialState = {
  sentToIndividual: [],
  loading: false,
  error: null,
};

export const sentToIndividualAPI = createAsyncThunk(
  "sentToIndividual",
  async ({ search, skip, limit, type }) => {
    var formData = {};

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }application/individual/applied/?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const sentToIndividualSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sentToIndividualAPI.pending, (state) => {
      state.sentToIndividual = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sentToIndividualAPI.fulfilled, (state, action) => {
      state.sentToIndividual = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(sentToIndividualAPI.rejected, (state, action) => {
      state.sentToIndividual = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default sentToIndividualSlice.reducer;
